module.exports = __webpack_public_path__ + "static/media/php.1f091d33.png";